import { ActionPlanReferrals } from '@features/action-plans/components/ActionPlanReferrals'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/action-plans/referrals')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Referrals'
        }
    }
})

function RouteComponent() {
    const { studentNo } = Route.useParams()

    return (
        <ActionPlanReferrals studentNo={studentNo} />
    )
}